export default __webpack_public_path__ + "static/media/terms-and-conditions.931cf917.pdf";